"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailType = exports.TemperatureUnit = exports.MeasurementSystem = void 0;
var MeasurementSystem;
(function (MeasurementSystem) {
    MeasurementSystem["METRIC"] = "metric";
    MeasurementSystem["IMPERIAL"] = "imperial";
})(MeasurementSystem || (exports.MeasurementSystem = MeasurementSystem = {}));
var TemperatureUnit;
(function (TemperatureUnit) {
    TemperatureUnit["CELSIUS"] = "C";
    TemperatureUnit["FAHRENHEIT"] = "F";
})(TemperatureUnit || (exports.TemperatureUnit = TemperatureUnit = {}));
var EmailType;
(function (EmailType) {
    EmailType["ATTACHMENT"] = "attachment";
    EmailType["LINK"] = "link";
})(EmailType || (exports.EmailType = EmailType = {}));
